import { Box, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { HsOpenSectionBox, HsOptionsSectionBox, HsOrderSectionBox, HsPinSectionBox } from './HsSectionBoxes'
import { useTranslation } from 'react-i18next'
import { useHomePageReorder } from '../atoms/homePageReorder'
import { SegmentOrderKeyType } from '../atoms/homeStatus'
import { useHomeSegmentConfiguration } from '../atoms/homePageSupport'

export type HomeSegmentPropsType = {
    title: SegmentOrderKeyType,
    nrec?: number,
    pinned?: boolean,
    onOptionsToggle?: (anchorEl: HTMLDivElement) => void,
}
export const HomeSegment: React.FunctionComponent<React.PropsWithChildren<HomeSegmentPropsType>> = ({ title, nrec, children, onOptionsToggle }) => {
    const [config, setConfig] = useHomeSegmentConfiguration(title)
    const { drag, preview, drop, opacity, dropSegment, isRightOver, order } = useHomePageReorder(title)
    const { t } = useTranslation()

    const handleToggleOpen = (ev: React.MouseEvent<HTMLDivElement>) => {
        ev.preventDefault()
        ev.stopPropagation()
        console.log(`Setting open for Preferiti: ${config.open}`)
        setConfig({ ...config, open: !config.open })
    }
    const handleOptionsToggle = (ev: React.MouseEvent<HTMLDivElement>) => {
        onOptionsToggle && onOptionsToggle(ev.currentTarget)
    }
    return (
        <>
            <Box ref={drop} sx={{
                borderTop: isRightOver ? 'solid 2px' : 'none',
                order: order,
                borderColor: theme => theme.palette.primary.main,
                pt: 1
            }}>
                {dropSegment
                    ? <Box sx={{ height: '40px', opacity: 0.01, border: 'dashed 1px #f0f0f0' }}></Box>
                    : <>
                        <Box ref={preview} sx={{
                            opacity,
                            //backgroundColor: grey[300],
                            backgroundColor: theme => theme.palette.primary.main,
                            py: 1,
                            mx: 0.5,
                            //color: theme => theme.palette.primary.main
                            color: '#FFFFFF'
                        }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 0.5 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <HsOpenSectionBox open={config.open} onAction={handleToggleOpen} />
                                    <HsPinSectionBox pin hide />
                                </Box>
                                <Box
                                    sx={{
                                        textAlign: 'center',
                                        flexGrow: 1,
                                        cursor: config.open ? 'zoom-out' : 'zoom-in', mx: 5,
                                        position: 'relative'
                                    }}
                                    onClick={handleToggleOpen}
                                >
                                    <Typography color='#FFFFFF' /*color='primary'*/>{t(`hs-${title}`)}</Typography>
                                    {!!nrec &&
                                        <Typography
                                            variant="overline"
                                            sx={{
                                                position: 'absolute',
                                                right: 0,
                                                top: 0,
                                                bottom: 0,
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <em>({nrec})</em>
                                        </Typography>
                                    }
                                </Box>
                                <Box ref={drag} sx={{ display: 'flex', mx: 1, alignItems: 'center', gap: 1 }}>
                                    <HsOptionsSectionBox onAction={handleOptionsToggle} hide={!onOptionsToggle} />
                                    <HsOrderSectionBox dragHandle={drag} order={order} />
                                </Box>
                            </Box>
                        </Box>
                        {config.open && children && children}
                    </>
                }
            </Box>
        </>
    )
}

export default HomeSegment
